const FeatureCard = ({ title, texts }) => (
  <div className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer">
    <h3 className="text-xl font-bold mb-2 text-gray-700">{title}</h3>
    <p>
      {texts.map((t, i) => (
        <span key={i}>
          {t} <br />
        </span>
      ))}
    </p>
  </div>
);

export default FeatureCard;